import React from 'react';
import "./Modal.css"
import {withSnackbar} from "notistack";
import Cookies from "js-cookie";

import {
    Modal,
} from 'react-bootstrap';

import PartnerApi from "../../services/ob-user/partner";

class ModalDeletePartnerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
            showBlock: true,
            signupInfo: null
        };
    }

    componentDidMount() {
        this.setState({reason: ''});
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.show) {
            this.setState({reason: ''});
        }
    }


    onDeletePartnerList = () => {
        let payload = {
            id: this.props.id,
            reason: this.state.reason,
        }
        console.log('ro>>>>>>>>>>',payload
        )
        PartnerApi.adminDelPartnerList(payload, res => {
            if (res.success) {
                this.props.enqueueSnackbar('Xoá tài khoản thành công !', {
                    variant: 'success',
                });

                this.props.onHide();
                this.props.onRefresh();
            } else {
                return this.props.enqueueSnackbar('Xoá không thành công !', {
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right"
                    },
                    variant: 'error',
                });
            }
        })
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>THÔNG BÁO</b></h1>
                        </div>
                        <div>
                            <label>Vui lòng nhập lý do trước khi xóa Partner:</label>
                            <textarea
                                rows={5}
                                className="form-control shadow-none"
                                style={{resize: 'none'}}
                                placeholder={'Lý do xóa Partner...'}
                                maxLength={200}
                                value={this.state.reason}
                                onChange={(event) => {
                                    this.setState({reason: event.target.value})
                                }}
                            />
                        </div>

                        <div container item xs={12}>
                            <div item xs={12}>
                                <div className="align-right mt-3 mb-2">
                                    <button
                                        type="button"
                                        className="ml-4 col-3 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                        disabled={this.state.reason?.length == 0}
                                        onClick={() => this.onDeletePartnerList()}
                                    >
                                        <span className='d-flex justify-content-center'>
                                            Xác nhận
                                        </span>
                                    </button>
                                    <button
                                        type="button"
                                        className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-light"
                                        // disabled={this.state.oldpassword?.length == 0 || this.state.newpassword?.length == 0 || this.state.repassword?.length == 0 }
                                        onClick={this.props.onHide}
                                    >
                                        <span className='d-flex justify-content-center'>
                                            Hủy
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


export default withSnackbar(ModalDeletePartnerList);

